import { Component, OnInit, Input } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';
import { TranslocoService } from '@ngneat/transloco';

declare var bootstrap: any;
import * as _ from 'lodash-es';
import moment from 'moment';
declare var require: any;

@Component({
  selector: 'app-worker-shift',
  templateUrl: './worker-shift.component.html',
  styleUrls: ['./worker-shift.component.scss']
})
export class WorkerShiftComponent implements OnInit {

  @Input() worker:any;

  events:any = [];
  shifts:any = [];
  timezone:any = "";

  calendarOptions:CalendarOptions = {
    initialView: 'dayGridMonth',
    plugins: [dayGridPlugin,interactionPlugin],
  }
  deepChangeDetection = true;

  constructor(public okService: OkAloneService, private transloco: TranslocoService) { }

  dayGroup = new FormGroup({
    start: new FormControl('',[Validators.required]),
    end: new FormControl('',[Validators.required]),
  });
  submitted = false;
  get f(): { [key: string]: AbstractControl } {
    return this.dayGroup.controls;
  }
  day_hours = Utils.getDayHours();

  month:any = null;
  edit_day:any = null;
  edit_day_str:any = null;

  settingGroup:any = null;
  settingsubmitted = false;
  get settingf(): { [key: string]: AbstractControl } {
    return this.settingGroup.controls;
  }
  startshift_time_items = [{name:"5 mins",value:5},{name:"10 mins",value:10},{name:"15 mins",value:15},{name:"20 mins",value:20},{name:"30 mins",value:30}];
  startshift_method_items = [{name:"Email",value:"Email"},{name:"Sms",value:"Sms"},{name:"Call",value:"Call"}];
  startshift_monitor_items = [{name:"Yes",value:true},{name:"No",value:false}];

  batch_times:any = Utils.getDayHours();

  copyGroup:any = null;
  batchGroup:any = null;
  batch_dates: any;

  workers_loading = false;
  groups_loading = false;
  batch_loading = false;

  ngOnInit(): void {


    this.settingGroup = new FormGroup({
      startshift_time: new FormControl(this.okService.settings.startshift_time,[Validators.required]),
      startshift_method: new FormControl(this.okService.settings.startshift_method,[Validators.required]),
      startshift_monitor: new FormControl(this.okService.settings.startshift_monitor,[Validators.required]),
    });


    this.copyGroup = new FormGroup({
      worker_ids: new FormControl([],[]),
      group_ids: new FormControl([],[]),
    });


    this.batchGroup = new FormGroup({
      start: new FormControl('',[]),
      end: new FormControl('',[]),
      type: new FormControl('start',[Validators.required]),
      time: new FormControl('',[Validators.required]),
      mon: new FormControl(false,[]),
      tue: new FormControl(false,[]),
      wed: new FormControl(false,[]),
      thu: new FormControl(false,[]),
      fri: new FormControl(false,[]),
      sat: new FormControl(false,[]),
      sun: new FormControl(false,[]),
    });
    this.batch_times[0] = {"value":'remove',"name":"Remove"};
    //console.log(this.batch_times);
    this.batch_dates = { startDate: moment(), endDate: moment() };

    //console.log(this.settingGroup);

    // Remove +1 from times
    this.day_hours.pop();
    this.batch_times.pop();

    this.getShifts();
  }

  getShifts(){

    let values = {};
    if(this.month){
      values = {month:this.month};
    }


    this.okService.get("startendshifts/"+this.worker.id,values)
    .subscribe((data:any) => {

      this.shifts = data.body['shifts'];
      this.timezone = data.body['timezone'];

      //console.log(this.shifts);

      this.setupEvents();

    });

  }

  setupEvents(){

    this.events = [];

    for (const shift of this.shifts) {

        let event = {
          title: shift.time,
          date: shift.date,
          type: shift.type,
          //start: moment(shift.date+" "+shift.time),
          backgroundColor: shift.type=='start' ? '#12a000' : '#ffac1e',
          borderColor: shift.type=='start' ? '#12a000' : '#ffac1e',
          order: shift.type=='start' ? 0 : 1,
          allDay: true,
        };


        this.events.push(event);

    }

    //console.log(this.events);


    this.calendarOptions = {
      initialView: 'dayGridMonth',
      plugins: [dayGridPlugin,interactionPlugin],
      themeSystem: 'bootstrap5',
      events: this.events,
      eventOrder: 'order',
      dateClick:  this.handleDateClick.bind(this),
      eventClick:  this.handleEventClick.bind(this),
      datesSet: this.handleDatesSetClick.bind(this),
    };

  }

  handleDateClick(arg:any) {
    //console.log("handleDateClick");
    let date = arg.dateStr;
    this.editDayTime(date);
  }

  handleEventClick(arg:any) {
    let date = moment(arg.event.start).format('YYYY-MM-DD');
    this.editDayTime(date);
  }

  handleDatesSetClick(arg:any) {
    //console.log(arg);

    let month = moment(arg.start).add(7, 'days').format('MMM YYYY');
    //console.log(month);
    this.month = month;
    this.getShifts();

  }

  addTime(){


  }

  editDayTime(date:string){

    //console.log(date);

    this.edit_day = date;
    this.edit_day_str = moment(date).format('dddd, MMMM Do YYYY');

    let dates = _.filter(this.shifts, function(o:any) { return o.date==date; });
    //console.log(dates);
    let start = _.find(dates, function(o:any) { return o.type=='start'; });
    let end = _.find(dates, function(o:any) { return o.type=='end'; });

    //console.log(start);
    //console.log(end);

    this.dayGroup.setValue({
        start: start ? start.time : "",
        end: end ? end.time : ""
    })

    var myModal = new bootstrap.Modal(document.getElementById('editDayModal'));
    myModal.show();


  }
  submitDayForm(){


      let values = this.dayGroup.value;

      let shifts:any = [
        {
          date: this.edit_day,
          type: "start",
          time: values.start ? values.start : ''
        },
        {
          date: this.edit_day,
          type: "end",
          time: values.end ? values.end : ''
        }
      ];

      //console.log(shifts);

      var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('editDayModal'));
      myModal.hide();

      this.okService.put("startendshifts/"+this.worker.id,{shifts:shifts})
      .subscribe((data:any) => {

        this.getShifts();

      });

  }

  submitSettingForm(){

    this.submitted = true;
    if (this.settingGroup.valid) {

        let values = this.settingGroup.value;
        //console.log('form values',values);

        this.okService.put("account",values)
        .subscribe((data) => {

          var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('settingsModal'));
          myModal.hide();

          this.okService.setAlert(this.transloco.translate("Your start shift settings have been updated"),"success");


        });

      }

    return false;

  }

  copyToGroups(){

    let group_ids = this.copyGroup.value.group_ids;
    if(group_ids.length > 0){

      this.groups_loading = true;


      this.okService.post("startendshifts/copy/"+this.worker.id,{group_ids:group_ids})
      .subscribe((data:any) => {

        this.groups_loading = false;

        var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('copyModal'));
        myModal.hide();

        //console.log(data.body);

        this.okService.setAlert(data.body['message'],"success");


      });
    }


  }

  copyToWorkers(){

    let worker_ids = this.copyGroup.value.worker_ids;
    if(worker_ids.length > 0){

      this.workers_loading = true;


      this.okService.post("startendshifts/copy/"+this.worker.id,{worker_ids:worker_ids})
      .subscribe((data:any) => {

        this.groups_loading = false;

        var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('copyModal'));
        myModal.hide();

        //console.log(data.body);

        this.okService.setAlert(data.body['message'],"success");


      });
    }


  }

  batchUpdate(){

    if (
      this.batchGroup.valid
      ) {
        let values = this.batchGroup.value
        //console.log(this.batchGroup.value);
        values.start = this.batch_dates.startDate.format("YYYY-MM-DD")
        values.end = this.batch_dates.endDate.format("YYYY-MM-DD")


        //console.log('dates',values);

        this.batch_loading = true;

        this.okService.post("startendshifts/batch/"+this.worker.id,{batch:values})
        .subscribe((data:any) => {


          this.batch_loading = false;

          var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('batchModal'));
          myModal.hide();


          this.getShifts();

          this.okService.setAlert(data.body['message'],"success");


        });

      }

  }

}
